/* OBFUSCATED CODE - INTELLECTUAL PROPERTY PROTECTED */
'use client';
import { useEffect, useRef } from 'react';
export function usePaintBridge(cans, setToolbarSprayPct, setToolbarRollerPct) {
    const cansRef = useRef(cans);
    useEffect(() => { cansRef.current = cans; }, [cans]);
    useEffect(() => {
        window.onMobilePaintUpdate = (canId, newPaint) => {
            const currentCans = cansRef.current;
            const updatedCan = currentCans.find(c => c.id === canId);
            if (!updatedCan) return;
            const pct = Math.round((newPaint / 10000) * 100);
            if (updatedCan.type === 'spray') {
                setToolbarSprayPct(pct);
            } else if (updatedCan.type === 'roller') {
                setToolbarRollerPct(pct);
            }
        };
        return () => { window.onMobilePaintUpdate = null; };
    }, []);
}
